module.exports = function(ctx) {
var __t, __p = '';
__p += '<div>\n	<div ref="modal">\n		<header class="modal-header border-0">\n			<h2 class="modal-title">' +
((__t = ( ctx.modalTitle )) == null ? '' : __t) +
'</h2>\n		</header>\n		<div class="modal-body" style="height: 100px">\n			<div class="loader-wrapper" style="background-color: transparent;">\n				<div class="loader text-center"></div>\n			</div>\n		</div>\n	</div>\n</div>\n';
return __p
}